import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'
import IconLink from 'components/Shared/IconLink/Index'

export const StyledBadge = styled.div`
  margin: ${props => props.margin || '8px'};
  border-radius: 8px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  color: ${colors.secondary20};
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0px;
  padding: 0 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  background: ${props => props.color};
  width: max-content;

  ${props => props.big && css`
    height: 24px;
    border-radius: 12px;
    font-size: 12px;
    letter-spacing: -0.4px;
    padding: 0 16px;
  `}
`

// we scale down 12px icon as browser may have setting limiting
// lower bound of font size (e.g. > 8px)
const DeleteIcon = styled(IconLink)`
  && {
    position: relative;
    left: 1px;
    padding: 0 0 0 4px;

    &:hover {
      background-color: transparent;
    }

    &:before {
      color: ${colors.secondary40} !important;
      transform: scale(0.5);
    }

    &:hover:before {
      color: red !important;
    }
  }
`

/**
 * Badge used to highlight important data in text like table cells.
 */
const Badge = ({
  color = colors.secondary80, big = false, children,
  margin, onDelete, className, deleteTooltip, deleteTooltipId, ...rest
}) => {
  return (
    <StyledBadge
      color={color}
      big={big}
      margin={margin}
      className={className}
      data-test='badge'
      {...rest}
    >
      {children}
      {!!onDelete && (
        <DeleteIcon
          iconName='icon-close-12'
          onClick={() => onDelete()}
          data-tooltip-content={deleteTooltip}
          data-tooltip-id={deleteTooltipId}
        />
      )}
    </StyledBadge>
  )
}

Badge.propTypes = {
  children: PropTypes.node,
  /** html compatible color string like "#4FC1AD", "red" */
  color: PropTypes.string,
  /** set true to use 3 unit height badge, default 2 unit height */
  big: PropTypes.bool,
  margin: PropTypes.string,
  /** if set, 'x' will appear */
  onDelete: PropTypes.func,
  deleteTooltip: PropTypes.string,
  deleteTooltipId: PropTypes.string,
}

export default Badge
